
const digest = '4f82c9a7ab08f8d635cd315305a8f2f59f8bdeedcd43668037ee4ef837b4a0e0';
const classes = {"wrapper":"_wrapper_xc83q_1","list":"_list_xc83q_10","title":"_title_xc83q_15"};
const css = `._wrapper_xc83q_1 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  position: relative;
}
._wrapper_xc83q_1 ._list_xc83q_10 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_xc83q_1 ._title_xc83q_15 {
  font-weight: 600;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  